import { FaRegEnvelopeOpen } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";

import { RiSendPlaneFill } from "react-icons/ri";
// import StyleOne from "../styleOne/StyleOne";
// import { StyleTwo } from "../styleTwo/StyleTwo";
import { Widget } from "../widget/Widget";
import "./MainBody.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getPosts } from "../../redux/features/post/postSlice";
import { addLike } from "../../redux/features/post/postSlice";
import { removeLike } from "../../redux/features/post/postSlice";

import moment from "moment";
import DOMPurify from "dompurify";
import { shortenText } from "../../utils";
import HeadingTitle from "../headingTitle/HeadingTitle";
import { MdOutlineThumbUpOffAlt, MdVisibility } from "react-icons/md";
import { Link } from "react-router-dom";
import { getAdverts } from "../../redux/features/add/addSlice";

export const MainBody = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPosts());
    dispatch(getAdverts());
  }, [dispatch]);

  useEffect(() => {
    dispatch(addLike());
  }, [dispatch]);

  useEffect(() => {
    dispatch(removeLike());
  }, [dispatch]);

  const { posts } = useSelector((state) => state.post);
  const { adds } = useSelector((state) => state.add);
  const worldNews = posts.find((post) => post?.category === "World News");
  const national = posts.find((post) => post?.category === "National");

  const adsMain = adds
    ?.filter((ads) => {
      return ads?.category === "Advert Main";
    })
    ?.filter((ads, index) => index < 4);

  const worldNewsB = posts
    ?.filter((news) => {
      return news?.category === "World News";
    })
    ?.filter((news, index) => index < 4);

  const nationalB = posts
    ?.filter((nation) => {
      return nation?.category === "National";
    })
    ?.filter((nation, index) => index < 4);

  return (
    <div className="mainBody ">
      <div className="mainBodyWrapper">
        {/* StyleOne left WorldNews*/}
        <div className="item">
          <div className="styleTwo">
            <HeadingTitle title={worldNews?.category} />

            <div className="top">
              <img src={worldNews?.image[0]} alt="" />
              <Link className="cat">{worldNews?.type}</Link>
              <Link className="icon">
                {" "}
                <MdVisibility style={{ fontSize: "20px" }} />
              </Link>
            </div>

            <div className="bottom">
              {worldNewsB.map((news) => {
                return (
                  <div className="item" key={news?._id}>
                    <div className="left">
                      <Link to={`/page/${news.slug}`}>
                        <img src={news?.image[0]} alt="" />
                      </Link>
                      <div className="likeComment">
                        <div className="left">
                          <div
                            className="lkicon"
                            onClick={(e) => dispatch(addLike(news?._id))}
                          >
                            <MdOutlineThumbUpOffAlt color="#ff9f31" size={20} />
                            {news?.likes?.length > 0 && news?.likes?.length}
                          </div>
                        </div>
                        <div className="right">
                          <Link to={`/page/${news.slug}`}>
                            <div className="cmticon">
                              <IoMdChatboxes color="#ff9f31" size={20} />
                              {news?.comments?.length > 0 &&
                                news?.comments?.length}
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="right">
                      <ul className="nav">
                        <li>{news?.author}</li>
                        <li>{moment(news?.createdAt).format("DD-MMM-YYYY")}</li>
                      </ul>
                      <Link to={`/page/${news.slug}`}>
                        <h3
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              shortenText(news?.title, 90)
                            ),
                          }}
                        ></h3>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* StyleTwo Right  Technology*/}
        <div className="item">
          <div className="styleTwo">
            <HeadingTitle title={national?.category} />

            <div className="top">
              <img src={national?.image[0]} alt="" />
              <Link className="cat">{national?.type}</Link>
              <Link className="icon">
                {" "}
                <MdVisibility style={{ fontSize: "20px" }} />
              </Link>
            </div>

            <div className="bottom">
              {nationalB.map((nation) => {
                return (
                  <div className="item" key={nation?._id}>
                    <div className="left">
                      <Link to={`/page/${nation?.slug}`}>
                        <img src={nation?.image[0]} alt="" />
                      </Link>
                      <div className="likeComment">
                        <div className="left">
                          <div className="lkicon">
                            <MdOutlineThumbUpOffAlt color="#ff9f31" size={20} />
                            {nation?.likes?.length > 0 && nation?.likes?.length}
                          </div>
                        </div>
                        <div className="right">
                          <div className="cmticon">
                            <IoMdChatboxes color="#ff9f31" size={20} />
                            {nation?.comments?.length > 0 &&
                              nation?.comments?.length}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="right">
                      <ul className="nav">
                        <li>{nation?.author}</li>
                        <li>
                          {moment(nation?.createdAt).format("DD-MMM-YYYY")}
                        </li>
                      </ul>
                      <Link to={`/page/${nation?.slug}`}>
                        <h3
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(
                              shortenText(nation?.title, 90)
                            ),
                          }}
                        ></h3>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* StyleThree Right  Widget*/}
        <div className="item">
          <Widget adsMain={adsMain} />
        </div>
      </div>
      <div className="advertMiddleWrapper">
        <Link>
          <div className="advert">
            <img src="assets/advertttt.gif" alt="Advertisement" />
          </div>
        </Link>

        <div className="newsLetter">
          <div className="top">
            <h2>Get newsLetter</h2>
            <FaRegEnvelopeOpen className="icon" />
          </div>
          <div className="bottom">
            <div className="bottomWrapper">
              <div className="content">
                <p>
                  Subscribe to our newsletter to get latest and exclusive
                  updates
                </p>
              </div>
              <form>
                <div className="formInput">
                  <input
                    type="email"
                    name="email"
                    placeholder="E-mail address"
                    autoComplete="off"
                    require
                    className="formControl"
                  />
                  <button type="submit" className="button">
                    <RiSendPlaneFill size={25} />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
